import { createSelector } from 'reselect';

export const selectJobCreateState = (state) => state?.jobCreateState;

export const selectErrorPostGroupOrders = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.errorPostGroupOrders
);

export const selectPostGroupOrdersResponse = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.postGroupOrdersResponse
);

export const selectIsProcessingPostGroupOrders = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.isProcessingPostGroupOrders
);

export const selectErrorPostBulkDayJob = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.errorPostBulkDayJob
);

export const selectPostBulkDayJobResponse = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.postBulkDayJobResponse
);

export const selectIsProcessingPostBulkDayJob = createSelector(
  selectJobCreateState,
  (jobCreate) => jobCreate.isProcessingPostBulkDayJob
);
